import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Select,
  MenuItem,
  FormControl,
  Button,
  TextField,
  Paper,
  Box,
  CircularProgress,
  Grid
} from "@mui/material";
import { useSnackbar } from "notistack";
import ApiService from "../../functions/apiService";
import ColorSelectInput from "../../components/Inputs/ColorSelectInput";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import Error from "../../components/Error/Error";
import SystemHeaderNav from "../../components/HeadersNav/SystemHeaderNav";
import AuthContext from "../../context/AuthContext";
import { toast } from 'react-toastify';

export default function GroupSettings() {
  // const { enqueueSnackbar } = useSnackbar();
  const [groupItems, setGroupItems] = useState([]);
  const [groupColors, setGroupColors] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [loading, setLoading] = useState(false);
  const letters = ["0", "A", "B", "C", "D"];
  const { permission, pages, pagesName } = useContext(AuthContext);
  let groupName = Object.keys(pagesName).includes("GROUP_HEADER_TEXT")
    ? pagesName.GROUP_HEADER_TEXT
    : "Group";
  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    setError,
    setValue,
    getValues,
    reset,
    watch,
  } = useForm();
  useEffect(() => {
    setFetching(true);
    ApiService.get("/getGroupsSetting/")
      .then(({ data }) => {
        let values = {};
        let colors = {};
        data.data.forEach((element) => {
          values[element.Var] = element.Value;
        });
        if (values["GROUP_DN_MAPPING"]) {
          setValue("GROUP_DN_MAPPING", values["GROUP_DN_MAPPING"]);
        }
        if (values["GROUP_1_DAY"]) {
          setValue("GROUP_1_DAY", values["GROUP_1_DAY"]);
        }
        if (values["GROUP_NAME"]) {
          setValue("GROUP_NAME", values["GROUP_NAME"]);
        }
        const groupColors = values["GROUP_COLOR"].substring(5).split(";");
        groupColors.map((element, index) => {
          colors[index + 1] = element;
          delete values["GROUP_COLOR"];
        });
        // console.log('groupColors', values, colors);
        setGroupItems(values);
        setGroupColors(colors);
        // reset(values);
        setFetching(false);
      })
      .catch(({ data }) => { });
  }, []);
  const onSubmit = async (data) => {
    setLoading(true);
    ApiService.post("/postGroupsSetting", {
      ...data,
      GROUP_COLOR: [
        data.GROUP_COLOR_1,
        data.GROUP_COLOR_2,
        data.GROUP_COLOR_3,
        data.GROUP_COLOR_4,
      ],
    })
      .then((data) => {
        setLoading(false);
        toast.success(data?.message)
        // enqueueSnackbar("Date is updated", { variant: "success" });
      })
      .catch(({ data }) => {
        setLoading(false);
        if (data && data.message) {
          toast.error(data?.message)
          // enqueueSnackbar(data.message, { variant: "error" });
        } else {
          toast.error("Date is invalid")
          // enqueueSnackbar("Date is invalid", { variant: "error" });
        }
        if (data.errors) {
          Object.entries(data.errors).forEach((value) => {
            setError(value[0], { message: value[1] });
          });
        }
      });
  };
  return (
    <>
      <SystemHeaderNav />
      <Paper className=" p-4" style={{ marginTop: "1rem" }}>
        {fetching && (
          <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
            <CircularProgress />
          </Box>
        )}
        {!fetching && (
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <Grid container className="mb-4">
                <Grid md={4} sm={12} className="px-1">
                  <FormControl margin="dense" required={true} fullWidth>
                    <label>Start {groupName}</label>
                    <TextField
                      size="small"
                      {...register("GROUP_DN_MAPPING")}
                      inputProps={{ type: "number" }}
                    />
                    {errors.GROUP_DN_MAPPING && (
                      <Error>{errors.GROUP_DN_MAPPING?.message}</Error>
                    )}
                  </FormControl>
                </Grid>
                <Grid md={4} sm={12} className="px-1">
                  <FormControl margin="dense" required={true} fullWidth>
                    <label>Start Date</label>
                    <TextField size="small" {...register("GROUP_1_DAY")} />
                    {errors.GROUP_1_DAY && (
                      <Error>{errors.GROUP_1_DAY?.message}</Error>
                    )}
                  </FormControl>
                </Grid>
                <Grid md={4} sm={12} className="px-1">
                  <FormControl margin="dense" required={true} fullWidth>
                    <label>{groupName} Type</label>
                    <Select
                      size="small"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      {...register("GROUP_NAME")}
                      defaultValue={getValues("GROUP_NAME")}
                    >
                      <MenuItem value="NUMERIC">Numbers</MenuItem>
                      <MenuItem value="TEXT">Text</MenuItem>
                    </Select>
                    {errors.GROUP_NAME && (
                      <Error>{errors.GROUP_NAME?.message}</Error>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
              <h4>{groupName} Colors</h4>
              {groupColors &&
                Object.entries(groupColors).map((index) => (
                  <div className="row justify-content-between align-content-center  my-2">
                    <label className="col-12 col-md-3 d-flex align-items-center ">
                      {watch("GROUP_NAME") == "TEXT"
                        ? groupName + " " + letters[index[0]]
                        : groupName + " " + index[0]}
                    </label>
                    <div className="col-12 col-md-9">
                      <ColorSelectInput
                        index={index[0]}
                        defaultValue={index[1]}
                        register={register}
                      />
                    </div>
                  </div>
                ))}
            </div>

            <div className="d-flex justify-content-end ">
              <ButtonTheme
                type="submit"
                color="primary"
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={25} color={"info"} />
                ) : (
                  "Save"
                )}
              </ButtonTheme>
            </div>
          </form>
        )}
      </Paper>
    </>
  );
}
